import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import Select, {SelectChangeEvent} from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

import Typography from '@mui/material/Typography';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';

import { useAppSelector, useAppDispatch } from '../../app/hooks';
import { SerializedError } from '../../util/types';
import {
  Ticket,
  TicketEditRequest,
  selectTicket,
  selectChildrenItems,
  toEditRequest,
} from './ticketSlice';
import { useTicketViewQuery, TicketItemsResponse } from '../../api/ticket';

interface QueryProps {
	ktype: string | null;
	onChange: (value: string | null) => void;
};

const options = [
	{id: '', name: 'None'},
	{id: '1', name: 'Area'},
	{id: '2', name: 'Goal'},
	{id: '3', name: 'Project'},
	{id: '4', name: 'Epic'},
	{id: '5', name: 'Deliverable'},
	{id: '6', name: 'Task'},
];

export default function KType({ktype, onChange}: QueryProps) {
	//c onsole.log("202411071728", ktype);
	const [value, setValue] = React.useState<string>(ktype ? ktype : '');
	const handleChange = (event: SelectChangeEvent) => {
		const v = event.target.value as string;
		setValue(v);
		onChange(v ? v : null);
	};

	return (
		<Select
			id="k-ticket-level-select"
			label="Type"
			size="small"
			value={value}
			onChange={handleChange}
		>
			{
				options.map( (element, index) => {
					return (<MenuItem key={element.id} value={element.id}>{element.name}</MenuItem>);
				})
			}
		</Select>
	);
}
